import api from "./index"

export async function getChats({
  offset = 0,
  limit = 10,
  search = "",
  isRequested = false,
  isUnread = false,
} = {}) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      offset,
      limit,
      search,
      is_requested: isRequested,
      is_unread: isUnread,
    },
  }
  return api.get("/v1/threads", config)
}

export async function getThreadChats({
  threadId,
  offset = 0,
  limit = 10,
  search = "",
} = {}) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      offset,
      limit,
      search,
    },
  }
  return api.get(`/v1/threads/${threadId}/chats`, config)
}

export async function postThreadChats({ threadId, message, files = [] } = {}) {
  try {
    if (files.length > 0) {
      const formData = new FormData()
      formData.append("message", message)
      files.forEach((file) => {
        formData.append("files", file)
      })
      return await api.post(`/v1/threads/${threadId}/chats`, formData)
    }
    return await api.post(`/v1/threads/${threadId}/chats`, { message })
  } catch (error) {
    if (
      error.response?.status === 400 &&
      error.response?.data?.details?.ticketStatus === "CLOSED"
    ) {
      throw { ...error.response.data, status: error.response.status }
    }
    throw error
  }
}

export async function uploadMediaFile({ threadId, mediaFile } = {}) {
  try {
    const formData = new FormData()
    formData.append("media_file", mediaFile)
    return await api.post(`/v1/threads/${threadId}/chats:files`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  } catch (error) {
    if (
      error.response?.status === 400 &&
      error.response?.data?.details?.ticketStatus === "CLOSED"
    ) {
      throw { ...error.response.data, status: error.response.status }
    }
    throw error
  }
}

export async function sendTemplate(threadId) {
  return api.post(`/v1/threads/${threadId}/chats:sendTemplate`)
}

export async function updateThreadRead(threadId) {
  return api.patch(`/v1/threads/${threadId}:updateRead`)
}
